<ul ngTree #tree="ngTree" class="basic-tree">
  <ng-template
    [ngTemplateOutlet]="treeNodes"
    [ngTemplateOutletContext]="{ nodes: dataSource(), parent: tree }"
  />
</ul>
<ng-template #treeNodes let-nodes="nodes" let-parent="parent">
  @for (node of nodes; track node.value) {
    <li
      ngTreeItem
      [parent]="parent"
      [value]="node.value"
      [label]="node.name"
      [disabled]="node.disabled"
      [expanded]="isExpanded(node.value)"
      [attr.aria-selected]="selectedValue() === node.value"
      (expandedChange)="onExpandedChange($event, node)"
      #treeItem="ngTreeItem"
    >
      <span
        aria-hidden="true"
        class="material-symbols-outlined expand-icon"
        translate="no"
      >
        {{ node.children ? 'chevron_right' : '' }}
      </span>
      <span
        class="node-content"
        (pointerdown)="$event.stopPropagation()"
        (click)="selectNode($event, node)"
      >
        <span
          aria-hidden="true"
          class="material-symbols-outlined"
          translate="no"
        >
          <img
            src="{{ node.icon | assetIcon }}"
            alt="{{ node.label }}"
            width="24"
            height="24"
          />
        </span>
        <span class="node-label">{{
          node.label | stripPrefix: (node.isRoot ? 'full' : 'short')
        }}</span>
      </span>
    </li>
    @if (node.children) {
      <ul role="group">
        <ng-template
          ngTreeItemGroup
          [ownedBy]="treeItem"
          #group="ngTreeItemGroup"
        >
          <ng-template
            [ngTemplateOutlet]="treeNodes"
            [ngTemplateOutletContext]="{ nodes: node.children, parent: group }"
          />
        </ng-template>
      </ul>
    }
  }
</ng-template>
